import { render, staticRenderFns } from "./SeleccionarEntitlementSga.vue?vue&type=template&id=6babe8e9&scoped=true"
import script from "./SeleccionarEntitlementSga.vue?vue&type=script&setup=true&lang=js"
export * from "./SeleccionarEntitlementSga.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SeleccionarEntitlementSga.vue?vue&type=style&index=0&id=6babe8e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6babe8e9",
  null
  
)

export default component.exports